/**
 * Determine the linked status at the start of the session based on query parameters or app initialization data.
 * When a user links their account, the app is reloaded using the users access token - in this case useAppInit
 * returns linked as true to reflect the users current link status. To preserve user's start of session linked
 * status, we add the linked status as a query parameter which SMA loads after auth flow is complete. Having this
 * distinction allows us to measure funnel metrics for users who started the shopping session as unlinked.
 *
 * For any use cases where we need the users current linked status - for eg: to display "Your account is connected",
 * use useAppInit.linked directly.
 */
export const getLinkedStatusAtSessionStart = (searchParams, linked) => {
    return searchParams.has('linked') ? searchParams.get('linked') === 'true' : !!linked;
};
